import React, { useState, useEffect } from "react";
import {
    Typography,
    Box,
    useTheme,
    TextField,
    Divider,
    Grid,
    Autocomplete,
    FormControlLabel,
    Switch,
    IconButton,
    Tooltip,
} from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { Warehouse_API_ENDPOINTS } from "../../../config/api/apiCallWarehouse";

import CallAlertBar from "../../../Layout/Alertbar";
import WarehouseMasterMenu from "./ActionMenu";


import useUserPermissions from "../../../components/user-permission/UserPermission";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";

import AddUpdateWarehouseType from "../masterwarehousetype/AddUpdateWarehouseType";
import AddUpdateWarehouseEnvironment from "../masterwarehouseenvironment/AddUpdateWarehouseEnvironment";
import RequiredLabel from "../../../components/RequiredLabel";
import useWarehouseTypeList from "../../../hooks/warehouse/useWarehouseTypeList";
import useWarehouseEnvironmentTypeList from "../../../hooks/warehouse/useWarehouseEnvironmentTypeList";



const AddNewWarehouse = ({ handleBackWinderMachineEntry, selectedwarehosue }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [result, setresult] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [warehouseCode, setWarehouseCode] = useState('');
    const [description, setDescription] = useState('');
    const [visibleDelete, setVisibleDelete] = useState(false);
    const [warehouseid, setWarehouseid] = useState(0);
    const [wipFlag, setWipFlag] = useState(false);
    const [status, setStatus] = useState(false);
    const [header, setHeader] = useState(0);
    const [selectedButtonName, setSelectedButtonName] = useState('');
    const [enableRejectParentRoll, setEnableRejectParentRoll] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(false);
    const { warehouseTypes,
        selectedWarehouseType,
        selectedWarehouseTypeID,
        setSelectedWarehouseType,
        setSelectedWarehouseTypeID,
        loadWarehouseTypeByID, } = useWarehouseTypeList(true, 0);


    const { warehouseEnvironmentTypes, selectedWarehouseEnvironmentType, selectedWarehouseEnvironmentTypeID, setSelectedWarehouseEnvironmentType, setSelectedWarehouseEnvironmentTypeID, loadWarehouseEnvironmentTypeByID } = useWarehouseEnvironmentTypeList(true, 0);


    const [isWarehousetypeOpen, setIsWarehousetypeOpen] = useState(false);
    const [isWarehouseEnvironmenttypeOpen, setIsWarehouseEnvironmenttypeOpen] = useState(false);
    const [warehouseFormData, setWarehouseFormData] = useState({});
    const userPermissions = useUserPermissions();



    const clear = () => {

        setWarehouseCode('');
        setDescription('');
        setSelectedWarehouseType(null);
        // setSelectedWarehouseBinType(null);
        setSelectedWarehouseEnvironmentType(null);
        setWipFlag(false);
        setWarehouseid(0);
        setVisibleDelete(false);
        setHeader(0);
        setStatus(true);
        loadWarehouseTypeByID(null);
        loadWarehouseEnvironmentTypeByID(null);
    }




    const handleWarehouseTypeChange = (event, value) => {


        if (value === null || value === undefined) {
            setSelectedWarehouseType(null);
            setSelectedWarehouseTypeID(null);
            return;
        }
        loadWarehouseTypeByID(value.warehouse_type_id);

    }
    const handleWarehouseEnvironmentTypeChange = (event, value) => {
        if (value === null || value === undefined) {
            setSelectedWarehouseEnvironmentType(null);
            setSelectedWarehouseEnvironmentTypeID(null);
            return;
        }
        loadWarehouseEnvironmentTypeByID(value.environment_type_id);

    }




    useEffect(() => {
        if (selectedwarehosue !== null && selectedwarehosue !== undefined) {
            LoadExitingWarehouseList();

        }
        else {
            clear();
        }
    }, [selectedwarehosue]);

    const LoadExitingWarehouseList = () => {
        setWarehouseCode(selectedwarehosue.code);
        setDescription(selectedwarehosue.description);
        loadWarehouseTypeByID(selectedwarehosue.warehouse_type_id);
        loadWarehouseEnvironmentTypeByID(selectedwarehosue.environment_type_id);

        setWipFlag(selectedwarehosue.wip_flag === 1 ? true : false);
        setWarehouseid(selectedwarehosue.warehouse_id);
        setVisibleDelete(true);
        setHeader(1);
        setStatus(selectedwarehosue.status);

    }






    const handlesavewarehousedetails = (mode, id) => {
        setParentRollMsgOpen(false);

        if (mode === "Delete" && !window.confirm("Are you sure you want to delete Warehouse?")) return;


        let isValid = true;
        let validation_msg = '';
        if (warehouseCode === '') {
            validation_msg += 'Please enter the Warehouse Code.\n';
            isValid = false;
        }

        if (description === '') {
            validation_msg += 'Please enter the Warehouse Description.\n';
            isValid = false;
        }

        if (selectedWarehouseTypeID === null) {
            validation_msg += 'Please select the Warehouse type\n';
            isValid = false;
        }

        if (selectedWarehouseEnvironmentTypeID === null) {
            validation_msg += 'Please select the Environment type.\n';
            isValid = false;
        }



        if (isValid) {
            const SaveData = {
                p_id: warehouseid,
                p_code: warehouseCode,
                p_description: description,
                p_warehouse_type_id: selectedWarehouseTypeID,
                p_environment_type_id: selectedWarehouseEnvironmentTypeID,
                p_default_bin_type_id: 1,
                p_wip_flag: wipFlag ? 1 : 0,
                p_company_id: localStorage.getItem('companyid'),
                p_plant_id: 1,
                p_created_by: localStorage.getItem('LoginID'),
                p_updated_by: localStorage.getItem('LoginID'),
                p_status: status
            };
            let endpoint = Warehouse_API_ENDPOINTS.warehouse.create;
            if (warehouseid) endpoint = Warehouse_API_ENDPOINTS.warehouse.update;
            if (mode === "Delete") endpoint = Warehouse_API_ENDPOINTS.warehouse.delete;


            callApi(endpoint, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setresult(data[0]);

                        if (data[0].message == 'Error: column \"warehouse_id\" does not exist') {
                            toast.error('warehouse_id does not exist', { position: toast.POSITION.BOTTOM_CENTER });
                        }

                        else if (data[0].message === 'Warehouse updated successfully.') {

                            toast.success(data[0].message, { position: toast.POSITION.BOTTOM_CENTER });


                        }
                        else if (data[0].message === 'Warehouse created successfully') {

                            toast.success(data[0].message, { position: toast.POSITION.BOTTOM_CENTER });
                            setWarehouseid(data[0].warehouse_id);
                            setVisibleDelete(true);
                            setHeader(1);
                        }
                        else if (data[0].message === 'Warehouse deleted successfully.') {

                            toast.success(data[0].message, { position: toast.POSITION.BOTTOM_CENTER });
                            handleBackWinderMachineEntry();
                        }
                        else if (data[0].message == 'Error: update or delete on table \"warehouse_new\" violates foreign key constraint \"fk_warehouse_id\" on table \"warehouse_storage_location\"') {


                            toast.warning('Cannot delete this warehouse because it is already used in storage locations', { position: toast.POSITION.BOTTOM_CENTER });
                        }
                        else if (data[0].message === 'Warehouse De-Activated successfully.') {
                            toast.success(data[0].message, { position: toast.POSITION.BOTTOM_CENTER });
                            handleBackWinderMachineEntry();
                        }

                        else {
                            toast.error(data[0].message, { position: toast.POSITION.BOTTOM_CENTER });
                        }

                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        } else {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
        }
    };

    const handlecallProcess = (buttonName) => {
        if (buttonName === 'save') {

            if (header === 0) {
                if (!hasPermission(userPermissions, "Warehouse master", "Create")) {
                    toast.warning('Access denied. You don’t have permission to this action.', { position: toast.POSITION.TOP_CENTER });
                    return; // Exit the function if permission is not granted
                }
            }

            else if (header === 1) {
                if (!hasPermission(userPermissions, "Warehouse master", "Update")) {
                    toast.warning('Access denied. You don’t have permission to this action.', { position: toast.POSITION.TOP_CENTER });
                    return; // Exit the function if permission is not granted
                }
            }


            handlesavewarehousedetails();
        }
        else if (buttonName === 'clear') {

            clear();
        }
        else if (buttonName === 'delete') {

            if (!hasPermission(userPermissions, "Warehouse master", "Delete")) {
                toast.warning('Access denied. You don’t have permission to this action.', { position: toast.POSITION.BOTTOM_CENTER });
                return; // Exit the function if permission is not granted
            }
            handlesavewarehousedetails('Delete', warehouseid);
        }


    };


    return (
        <>
            {!isWarehousetypeOpen && !isWarehouseEnvironmenttypeOpen && (


                <Box

                    fullWidth

                >
                    <>
                        <WarehouseMasterMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} enableRejectParentRoll={enableRejectParentRoll} title={header} callback={handleBackWinderMachineEntry} saveButtonDisabled={saveButtonDisabled} visibleDelete={visibleDelete} header={header} />
                        <Divider />
                    </>

                    <Box p={2} spacing={2} >

                        <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                            setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                            setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                        <Grid container spacing={2} sx={{ width: '100%', p: 0.5 }} >
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >
                                <Box
                                    display="grid"
                                    gridTemplateColumns={{
                                        xs: 'repeat(2, 1fr)',
                                        sm: 'repeat(2, 1fr)',
                                        md: 'repeat(3, 1fr)',
                                        lg: 'repeat(12, 1fr)',
                                        xl: 'repeat(12, 1fr)',
                                    }}
                                    gridAutoRows="10px"
                                    gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                    marginTop={0}
                                >
                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 2',
                                            xl: 'span 2',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"
                                    >
                                        <RequiredLabel label="Code" />
                                    </Box>

                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 2',
                                            xl: 'span 2',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"

                                    >

                                        <TextField placeholder="Code"  disabled={header === 1}  size="small" value={warehouseCode} onChange={(e) => setWarehouseCode(e.target.value)} color="secondary" fullWidth />

                                    </Box>
                                </Box>

                                <Box
                                    display="grid"
                                    gridTemplateColumns={{
                                        xs: 'repeat(2, 1fr)',
                                        sm: 'repeat(2, 1fr)',
                                        md: 'repeat(3, 1fr)',
                                        lg: 'repeat(12, 1fr)',
                                        xl: 'repeat(12, 1fr)',
                                    }}
                                    gridAutoRows="10px"
                                    gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                    marginTop={5}
                                >
                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 2',
                                            xl: 'span 2',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"
                                    >


                                        <RequiredLabel label="Description" />
                                    </Box>

                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 4',
                                            xl: 'span 4',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"

                                    >


                                        <TextField size="small" color="secondary" placeholder="Enter Description" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth />       </Box>

                                </Box>


                                <Box
                                    display="grid"
                                    gridTemplateColumns={{
                                        xs: 'repeat(2, 1fr)',
                                        sm: 'repeat(2, 1fr)',
                                        md: 'repeat(3, 1fr)',
                                        lg: 'repeat(12, 1fr)',
                                        xl: 'repeat(12, 1fr)',
                                    }}

                                    gridAutoRows="10px"
                                    gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                    marginTop={5}
                                >
                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 2',
                                            xl: 'span 2',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"
                                    >

                                        <RequiredLabel label="Warehouse type" />
                                    </Box>

                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 4',
                                            xl: 'span 4',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"

                                    >

                                        <Autocomplete
                                            fullWidth
                                            value={selectedWarehouseType}
                                            onChange={handleWarehouseTypeChange}
                                            size="small"
                                            options={warehouseTypes}
                                            getOptionLabel={(option) => `${option.code}`}
                                            renderInput={(params) =>
                                                <TextField required
                                                    color="secondary"
                                                    placeholder="Select Warehouse type"
                                                    helperText={errorMessage}
                                                    error={errorMessage && errorMessage.length ? true : false}
                                                    {...params} variant="outlined" />}
                                        />



                                    </Box>

                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 1',
                                            xl: 'span 1',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"

                                    >

                                        <Tooltip title="Add Warehouse type">
                                            <IconButton

                                                onClick={() => {
                                                    setWarehouseFormData({})
                                                    setIsWarehousetypeOpen(true)
                                                }}
                                            >
                                                <AddCircleOutline color="secondary" />
                                            </IconButton>
                                        </Tooltip>



                                    </Box>



                                </Box>


                                <Box
                                    display="grid"
                                    gridTemplateColumns={{
                                        xs: 'repeat(2, 1fr)',
                                        sm: 'repeat(2, 1fr)',
                                        md: 'repeat(3, 1fr)',
                                        lg: 'repeat(12, 1fr)',
                                        xl: 'repeat(12, 1fr)',
                                    }}

                                    gridAutoRows="10px"
                                    gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                    marginTop={5}
                                >
                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 2',
                                            xl: 'span 2',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"
                                    >

                                        <RequiredLabel label="Environment type" />
                                    </Box>

                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 4',
                                            xl: 'span 4',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"

                                    >

                                        <Autocomplete
                                            fullWidth
                                            value={selectedWarehouseEnvironmentType}
                                            onChange={handleWarehouseEnvironmentTypeChange}
                                            size="small"
                                            options={warehouseEnvironmentTypes}
                                            getOptionLabel={(option) => `${option.code}`}
                                            renderInput={(params) =>
                                                <TextField required
                                                    color="secondary"
                                                    placeholder="Select Environment type"
                                                    helperText={errorMessage}
                                                    error={errorMessage && errorMessage.length ? true : false}
                                                    {...params} variant="outlined" />}
                                        />

                                    </Box>

                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 1',
                                            xl: 'span 1',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"

                                    >

                                        <Tooltip title="Add Environment type">
                                            <IconButton
                                                onClick={() => {
                                                    setWarehouseFormData({})              // reset the form
                                                    setIsWarehouseEnvironmenttypeOpen(true) // open modal
                                                }}
                                            >
                                                <AddCircleOutline color="secondary" />
                                            </IconButton>
                                        </Tooltip>




                                    </Box>

                                </Box>


                                <Box
                                    display="grid"
                                    gridTemplateColumns={{
                                        xs: 'repeat(2, 1fr)',
                                        sm: 'repeat(2, 1fr)',
                                        md: 'repeat(3, 1fr)',
                                        lg: 'repeat(12, 1fr)',
                                        xl: 'repeat(12, 1fr)',
                                    }}

                                    gridAutoRows="10px"
                                    gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                    marginTop={5}
                                >
                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 2',
                                            xl: 'span 2',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"
                                    >
                                        <Typography variant="h6">WIP Flag</Typography>
                                    </Box>

                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 5',
                                            xl: 'span 5',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"
                                    >
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={wipFlag}
                                                    onChange={(e) => setWipFlag(e.target.checked)}
                                                    color="secondary"
                                                />
                                            }
                                            label={wipFlag ? 'True' : 'False'}
                                        />
                                    </Box>
                                </Box>

                                <Box
                                    display="grid"
                                    gridTemplateColumns={{
                                        xs: 'repeat(2, 1fr)',
                                        sm: 'repeat(2, 1fr)',
                                        md: 'repeat(3, 1fr)',
                                        lg: 'repeat(12, 1fr)',
                                        xl: 'repeat(12, 1fr)',
                                    }}

                                    gridAutoRows="10px"
                                    gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                    marginTop={5}
                                >
                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 2',
                                            xl: 'span 2',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"
                                    >
                                        <Typography variant="h6">Status</Typography>
                                    </Box>

                                    <Box
                                        gridColumn={{
                                            xs: 'span 2',
                                            sm: 'span 11',
                                            md: 'span 11',
                                            lg: 'span 5',
                                            xl: 'span 5',
                                        }}
                                        display="flex"
                                        alignItems="start"
                                        justifyContent="start"
                                    >
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={status}
                                                    onChange={(e) => setStatus(e.target.checked)}
                                                    color="secondary"
                                                    disabled={header === 0}   // <-- this line is the magic
                                                />

                                            }
                                            label={status ? 'Active' : 'Inactive'}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>)}


            {isWarehousetypeOpen && (
                <AddUpdateWarehouseType
                    warehouseFormData={warehouseFormData}
                    setWarehouseFormData={setWarehouseFormData}
                    setIsFormOpen={setIsWarehousetypeOpen}
                    LoadWarehouseList={loadWarehouseTypeByID}
                />
            )}

            {isWarehouseEnvironmenttypeOpen && (
                <AddUpdateWarehouseEnvironment
                    envFormData={warehouseFormData}
                    setEnvFormData={setWarehouseFormData}
                    setIsFormOpen={setIsWarehouseEnvironmenttypeOpen}
                    LoadEnvironmentList={loadWarehouseEnvironmentTypeByID}
                />
            )}

        </>
    );
};
export default AddNewWarehouse; 